import { ColumnOptionsUtils } from "library/greco-components";
import { atom } from "jotai";
import { ExpandedColumn } from "library/types/columns";
import { LoadStatus, Setting } from "library/types/types";
import { OffersShowMode } from "state/queries/useGetOffers";

// Basic pagination and search atoms
export const proposalsPageSearchState = atom<string>("");
export const proposalsPageSkipState = atom<number>(0);
export const proposalsPageTotalState = atom<number>(0);
export const proposalsPageTopState = atom<number>(25);
export const proposalsPageSortState = atom<{ key: string; dir: string }>({
  key: "",
  dir: "",
});
export const proposalsPageProductFilterState = atom<"all" | "mtpl" | "casco">(
  "all"
);
// admin filter: all entries, valid entries (not marked as error) or error entries
export const proposalsPageShowModeState = atom<OffersShowMode>("valid");

// Data atoms
export const proposalsPageColumnsState = atom<ExpandedColumn[]>([]);
export const proposalsPageRowsState = atom<any[]>([]);
export const proposalsPageSelectedViewColumnsState = atom<
  ExpandedColumn[] | null
>(null);
export const proposalsPageSelectedViewIdState = atom<number | null>(null);
export const proposalsPageSelectedViewState = atom<any>(null);
export const proposalsPageTempColumnsState = atom<ExpandedColumn[]>([]);

// Settings atoms
export const proposalsPageSettingsState = atom<Setting[]>([]);
export const proposalsPageColumnOptionsSettingsState = atom<Setting[]>([]);

// Load status atoms
export const proposalsPageSettingsLoadStatusState = atom<LoadStatus>("none");
export const proposalsPageOfferItemsLoadStatusState = atom<LoadStatus>("none");
export const proposalsPageInvalidateOfferStatusState = atom<LoadStatus>("none");
export const proposalsPageInsurerReportStatusState = atom<LoadStatus>("none");
export const proposalsPageSubmitInsurerReportFormStatusState =
  atom<LoadStatus>("none");

// UI state atoms
export const proposalsPageShowInvalidatedState = atom<boolean>(false);
export const proposalsPageSelectedItemsState = atom<any[]>([]);

// Dialog atoms
export const proposalsPageInvalidateOfferDialogState = atom<{
  isOpen: boolean;
  offer: any | null;
}>({ isOpen: false, offer: null });

export const proposalsPageInsurerReportDialogState = atom<{
  isOpen: boolean;
  formData: any | null;
}>({ isOpen: false, formData: null });

// Excel data atom
export const proposalsPageXlsVehicleItemsState = atom<any[]>([]);

// Computed atoms
export const areAnyColumnsFilteredState = atom((get) => {
  const columns = get(proposalsPageColumnsState);
  return columns.some((col) => ColumnOptionsUtils.isColumnFiltered(col.filter));
});

export const proposalsPageAreAnyColumnsFilteredState = atom((get) => {
  const columns = get(proposalsPageColumnsState);
  return columns.some((col) => ColumnOptionsUtils.isColumnFiltered(col.filter));
});
